import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPromotionmag = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 16,
	width: 16,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "#fff",
		children: [/* @__PURE__ */ _jsx("path", { d: "m15.853 9.149-9-9a.497.497 0 0 0 -.354-.146l-5.996-.003a.5.5 0 0 0 -.5.5l-.003 6c0 .132.052.26.146.353l9.002 9a.5.5 0 0 0 .707 0l5.998-5.998a.5.5 0 0 0 0-.707zm-6.352 5.644-8.501-8.499.003-5.294 5.289.003 8.501 8.5z" }), /* @__PURE__ */ _jsx("path", { d: "m5.168 8.832a.57.57 0 0 0 .808 0l2.856-2.856a.57.57 0 1 0 -.808-.808l-2.856 2.856a.57.57 0 0 0 0 .808zm2 2a.57.57 0 0 0 .808 0l2.856-2.856a.57.57 0 1 0 -.808-.808l-2.856 2.856a.57.57 0 0 0 0 .808zm-3.878-7.549a1.023 1.023 0 0 0 0 1.426 1 1 0 0 0 1.42-.01 1.01 1.01 0 0 0 0-1.416c-.37-.372-1.04-.382-1.42 0z" })]
	})
});
export default SvgPromotionmag;
